import { WizardItemType, Zone } from '@gimlite/ui-v1';
import { useTranslation } from '@gimlite/common';
import { useEffect, useState } from 'react';
import { v4 as uuidv4 } from 'uuid';
import { ContractMotoristLine } from '../../../../composition/line/contract-motorist.line';
import { ContractWizardInfos } from '../../../../composition/wizard-infos/contract.wizard-infos';
import { ConfirmationForm } from '../../../../form/confirmation/confirmation.form';
import { CreateNewSingleContractWizardContext } from '../../createNewSingleContract.wizard';

export const ConfirmationStep = ({
  context: {
    product: { id: productId },
    contractBase,
    contractDetails,
  },
}: WizardItemType.Config.Component<CreateNewSingleContractWizardContext>) => {
  const { t, lang } = useTranslation();

  const [allFeatures, setAllFeatures] = useState<JSX.Element[]>([]);

  useEffect(() => {
    const features: JSX.Element[] = [];

    features.push(
      <ContractMotoristLine
        data={{
          firstName: contractDetails.name1,
          lastName: contractDetails.name2,
          contractId: t('willBeGenerated'),
          status: contractBase.state ? 'ACTIVE' : 'SUSPENDED',
        }}
        config={{ action: false }}
      />,
    );

    setAllFeatures(features);
  }, [lang]);

  return (
    <Zone
      config={{
        gap: {
          y: 1,
          x: 1,
        },
        zones: [['info', 'list']],
        rows: ['1fr'],
        columns: ['min-content', '1fr'],
      }}
    >
      <Zone.Area config={{ area: 'info' }}>
        <ContractWizardInfos
          data={{
            productName: productId ? t(`product-${productId}-name`) : null,
            APBMode: contractBase.APBMode,
            APBNext:
              contractBase.APBMode !== 'NONE' ? contractBase.APBNext : null,
            state: contractBase.state,
            startDate: contractBase.startDate,
            endDate: contractBase.endDate,
            description: contractBase.description,
            reference: contractBase.reference,
            articleCode: contractBase.articleCode,
          }}
        />
      </Zone.Area>

      <Zone.Area config={{ area: 'list' }}>
        <ConfirmationForm
          data={{
            list: allFeatures.map((node) => {
              return {
                _id: uuidv4(),
                items: {
                  component: node,
                },
              };
            }),
          }}
        />
      </Zone.Area>
    </Zone>
  );
};
